export default __webpack_public_path__ + "static/media/9.648acce0.jpg";